import { AuthToken, CustomerContext } from '@typesApp/Customer'
import { logger } from '@utils/logger'

const KEY_CUSTOMER_CONTEXT = 'direct-billing.cc'

type CustomerContextState = {
  guestCustomerNumber: string
  accessToken: string
}

export const isPersistLocalCustomerContext = (customerContext: CustomerContext, authToken: AuthToken): boolean => {
  return Boolean(customerContext?.customerType === 'GUEST' && authToken?.accessToken)
}

export const setLocalCustomerContextState = (authToken: AuthToken) => {
  const { accessToken, customerNumber } = authToken
  const state: CustomerContextState = {
    guestCustomerNumber: customerNumber,
    accessToken,
  }

  try {
    sessionStorage.setItem(KEY_CUSTOMER_CONTEXT, JSON.stringify(state))
  } catch (e) {
    logger.error(e)
  }
}

export const getLocalCustomerContextState = (): CustomerContextState | null => {
  try {
    const value = sessionStorage.getItem(KEY_CUSTOMER_CONTEXT)
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (e) {
    logger.error(e)
    return null
  }
}

export const clearLocalCustomerContextState = () => {
  sessionStorage.removeItem(KEY_CUSTOMER_CONTEXT)
}
